import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { AuthProvider } from './context/AuthContext';
import { RegionProvider } from './context/RegionContext';
import { applyPendingClear } from './hooks/usePersistedMapState';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Oceanographic data for a given date never changes once generated.
      // Keep data fresh for 5 minutes to avoid redundant refetches.
      staleTime: 5 * 60 * 1000,
      // Liberar del cache las respuestas inactivas pronto: los .asc pesan ~6.7 MB
      // y retenerlos 30 min agotaba la RAM en equipos modestos.
      gcTime: 5 * 60 * 1000,
      // Don't refetch on tab switch — users don't expect it
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

// Clear persisted state if reset was requested (before any component reads localStorage)
applyPendingClear();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RegionProvider>
          <RouterProvider router={router} />
        </RegionProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
